import { validate } from '@feathr/rachis';

/**
 * Validates a proposed new name for a donation form.
 *
 * @param oldName - The current form name.
 * @param newName - The candidate new name entered by the user.
 * @returns A flat list of error messages, or an empty array if the name is valid.
 */
export function validateDonationFormName({
  oldName,
  newName,
}: {
  oldName: string;
  newName?: string;
}): string[] {
  const error = validate(
    { oldName, newName },
    {
      newName: {
        presence: {
          allowEmpty: false,
          message: '^Name cannot be empty',
        },
        equality: {
          attribute: 'oldName',
          message: '^New name cannot be the same as the current name',
          comparator: (value: string, other: string) => value !== other,
        },
      },
    },
    { format: 'flat' },
  );
  return error ?? [];
}
